import {
    SystemNotFoundMaintainerEnphaseTroubleshooting,
    TeslaTroubleshooting,
    SystemNotFoundGeneracTroubleshooting,
    ConnectionDelayedTroubleshooting,
    ConnectionPendingTroubleshooting,
    SystemNotFoundTroubleshooting,
    IconClockSnoozed,
    IconLoading01,
    IconSearch,
    IconSize
} from '@/components'
import { SystemStatusEnum } from '@/enums'
import { SystemStatusDataType } from '@/types'

export const SYSTEM_STATUSES_UNMONITORED: SystemStatusDataType[] = [
    {
        value: SystemStatusEnum.PENDING,
        title: 'Connection Pending',
        refreshable: true,
        icon: (size: IconSize) => <IconLoading01 size={size}/>,
        troubleshooting: {
            tesla: <TeslaTroubleshooting/>,
            default: <ConnectionPendingTroubleshooting/>
        },
        description: {
            tesla: 'We are still working to connect the site. This status is normal for new warranties and may take' +
                ' up to 10 days to resolve. To expedite the connection, follow the instructions below.',
            default: 'Initial status for newly enrolled warranties, indicating the initial efforts to match with' +
                ' the manufacturer\'s database, typically transitioning to a Connected Site status within two weeks.'
        }
    },
    {
        value: SystemStatusEnum.DELAYED,
        title: 'Connection Delayed',
        refreshable: true,
        icon: (size: IconSize) => <IconClockSnoozed size={size}/>,
        troubleshooting: {
            tesla: <TeslaTroubleshooting/>,
            default: <ConnectionDelayedTroubleshooting/>
        },
        description: {
            tesla: 'No Tesla DIN was entered in the Manufacturer System Identifier field on the warranty enrollment.' +
                ' We cannot connect this site to monitoring until that step is complete. Please update the' +
                ' Manufacturer System ID field and follow the instructions below.',
            default: 'Indicates a site remains unmonitored beyond 10 days or after three connection attempts,' +
                ' suggesting matching difficulties; resolution can be expedited by verifying address details or' +
                ' providing the system ID.'
        }
    },
    {
        value: SystemStatusEnum.SYSTEM_NOT_FOUND,
        title: 'System Not Found',
        refreshable: true,
        icon: (size: IconSize) => <IconSearch size={size}/>,
        troubleshooting: {
            generac: <SystemNotFoundGeneracTroubleshooting/>,
            tesla: <TeslaTroubleshooting/>,
            maintainer: { enphase: <SystemNotFoundMaintainerEnphaseTroubleshooting/> },
            default: <SystemNotFoundTroubleshooting/>
        },
        description: {
            tesla: 'Your company has submitted Tesla credentials or connected other Tesla warranties, but we weren’t' +
                ' able to find or match this specific site. Please verify that the Tesla DIN is correct and that the' +
                ' site has been shared with Solar Insure in Powerhub.',
            default: 'We were unable to locate the system ID enrolled for this warranty in the inverter' +
                ' manufacturer\'s database. This may be due to incorrect entry or data sharing issues. Please verify' +
                ' the system ID and/or ensure Solar Insure is authorized as a subcontractor in the manufacturer\'s' +
                ' monitoring portal.'
        }
    }
]
